import Http from '../../http';
import { formatDateForShop } from '../../common/helpers/times';
import { downloadCsv } from '../../main/reports/helpers';
import { SET_PRODUCT_INVENTORY, SET_PRODUCT_SHRINKAGE, SET_PRODUCT_VALUATION } from './constants';

const fetchInventoryReport = (url, fromDate, toDate, actions = []) => dispatch =>
  Http.get(
    url,
    {
      dateTime__gte: fromDate,
      dateTime__lte: toDate,
      ...(actions.length && { action__in: actions.join(',') }),
    }
  ).then(data => (
    dispatch({
      type: SET_PRODUCT_INVENTORY,
      payload: data,
    })
  ));

export const fetchShopInventoryReport = (shopId, fromDate, toDate, actions) => {
  const url = `/shop/${shopId}/product/inventory`;
  return fetchInventoryReport(url, fromDate, toDate, actions);
};

export const fetchBarberInventoryReport = (barberId, fromDate, toDate, actions) => {
  const url = `/barber/${barberId}/product/inventory`;
  return fetchInventoryReport(url, fromDate, toDate, actions);
};

const getInventoryReportCsv = (url, shopName, fromDate, toDate, timezone, actions = []) => {
  const filters = {
    view: 'csv',
    dateTime__gte: fromDate,
    dateTime__lte: toDate,
    ...(actions.length && { action__in: actions.join(',') }),
  };

  return Http.getRaw(url, filters).then((data) => (
    downloadCsv(
      data,
      `${shopName} - Inventory report ${formatDateForShop(fromDate)} to ${formatDateForShop(toDate)}`
    )
  ));
};

export const getShopInventoryReportCsv = (shopId, name, fromDate, toDate, timezone, actions) => {
  const url = `/shop/${shopId}/product/inventory`;
  return getInventoryReportCsv(url, name, fromDate, toDate, timezone, actions);
};

export const getBarberInventoryReportCsv = (barberId, name, fromDate, toDate, timezone, actions) => {
  const url = `/barber/${barberId}/product/inventory`;
  return getInventoryReportCsv(url, name, fromDate, toDate, timezone, actions);
};

const fetchShrinkageReport = url => dispatch =>
  Http.get(url).then(data => (
    dispatch({
      type: SET_PRODUCT_SHRINKAGE,
      payload: data,
    })
  ));

export const fetchShopShrinkageReport = (shopId, fromDate, toDate) => {
  const url = `/shop/${shopId}/product/inventory/shrinkage-report/${fromDate}/${toDate}`;
  return fetchShrinkageReport(url);
};

export const fetchBarberShrinkageReport = (barberId, fromDate, toDate) => {
  const url = `/barber/${barberId}/product/inventory/shrinkage-report/${fromDate}/${toDate}`;
  return fetchShrinkageReport(url);
};

const getShrinkageReportCsv = (url, shopName, fromDate, toDate, timezone) => {
  const filters = { view: 'csv' };
  return Http.getRaw(url, filters).then((data) => {
    return downloadCsv(
      data,
      `${shopName} - Shrinkage report ${formatDateForShop(fromDate)} to ${formatDateForShop(toDate)}`
    );
  });
};

export const getShopShrinkageReportCsv = (shopId, name, fromDate, toDate, timezone) => {
  const url = `/shop/${shopId}/product/inventory/shrinkage-report/${fromDate}/${toDate}`;
  return getShrinkageReportCsv(url, name, fromDate, toDate, timezone);
};

export const getBarberShrinkageReportCsv = (barberId, name, fromDate, toDate, timezone) => {
  const url = `/barber/${barberId}/product/inventory/shrinkage-report/${fromDate}/${toDate}`;
  return getShrinkageReportCsv(url, name, fromDate, toDate, timezone);
};

const fetchValuationReport = url => dispatch =>
  Http.get(url).then(data => (
    dispatch({
      type: SET_PRODUCT_VALUATION,
      payload: data,
    })
  ));

export const fetchShopValuationReport = (shopId, fromDate, toDate) => {
  const url = `/shop/${shopId}/product/inventory/valuation/${fromDate}/${toDate}`;
  return fetchValuationReport(url);
};

export const fetchBarberValuationReport = (barberId, fromDate, toDate) => {
  const url = `/barber/${barberId}/product/inventory/valuation/${fromDate}/${toDate}`;
  return fetchValuationReport(url);
};

const getValuationReportCsv = (url, shopName, fromDate, toDate, timezone) => {
  const filters = { view: 'csv' };
  return Http.getRaw(url, filters).then((data) => {
    return downloadCsv(
      data,
      `${shopName} - Valuation report ${formatDateForShop(fromDate)} to ${formatDateForShop(toDate)}`
    );
  });
};

export const getShopValuationReportCsv = (shopId, name, fromDate, toDate, timezone) => {
  const url = `/shop/${shopId}/product/inventory/valuation/${fromDate}/${toDate}`;
  return getValuationReportCsv(url, name, fromDate, toDate, timezone);
};

export const getBarberValuationReportCsv = (barberId, name, fromDate, toDate, timezone) => {
  const url = `/barber/${barberId}/product/inventory/valuation/${fromDate}/${toDate}`;
  return getValuationReportCsv(url, name, fromDate, toDate, timezone);
};
